import subscribeStore from "@kiwicom/frontend-common/browser/subscribeStore"

export default function postRender(store) {
  subscribeStore(store)
}
